import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class SettingsService {
  private static TenantIdKey = 'TenantId';
  private static SiteIdKey = 'SiteId';
  private static UltiProUrlKey = 'UltiProUrl';
  private static UltiProCountry = 'UltiProCountry';
  private static Alias = 'Alias';
  private static LoginToken = 'LoginToken';
  private static UserId = 'UserId';
  private static ArNumber = 'ArNumber';
  private static Locale = 'Locale';
  private static Email = 'Email';


  SettingsInitialized = new Subject<void>();

  constructor() {}

  get tenantId() {
    const tenantId = this.get(SettingsService.TenantIdKey);

    if (!environment.production && !tenantId) {
      // if not production and there isn't a tenantId in localstorage return CALEN.
      return environment.tenantId;
    }

    return tenantId;
  }

  set tenantId(id: string) {
    this.set(SettingsService.TenantIdKey, id);
  }

  get siteId() {
    return this.get(SettingsService.SiteIdKey) || '';
  }

  set siteId(siteId: string) {
    this.set(SettingsService.SiteIdKey, siteId);
  }

  get ultiproUrl() {
    return this.get(SettingsService.UltiProUrlKey) || '';
  }

  set ultiproUrl(url: string) {
    this.set(SettingsService.UltiProUrlKey, url);
  }

  get ultiproCountry() {
    return this.get(SettingsService.UltiProCountry) || '';
  }

  set ultiproCountry(country: string) {
    this.set(SettingsService.UltiProCountry, country);
  }

  get alias() {
    const alias = this.get(SettingsService.Alias);

    return alias || environment.alias;
  }

  set alias(siteId: string) {
    this.set(SettingsService.Alias, siteId);
  }

  get loginToken() {
    return this.get(SettingsService.LoginToken) || '';
  }

  set loginToken(loginToken: string) {
    this.set(SettingsService.LoginToken, loginToken);
  }

  get userId() {
    return this.get(SettingsService.UserId) || '';
  }

  set userId(userId: string) {
    this.set(SettingsService.UserId, userId);
  }

  get arNumber() {
    return this.get(SettingsService.ArNumber) || '';
  }

  set arNumber(arNumber: string) {
    this.set(SettingsService.ArNumber, arNumber);
  }

  get locale() {
    return this.get(SettingsService.Locale) || '';
  }

  set locale(locale: string) {
    this.set(SettingsService.Locale, locale);
  }

  get email() {
    return this.get(SettingsService.Email);
  }

  set email(email: string) {
    this.set(SettingsService.Email, email);
  }

  private get(key: string) {
    return sessionStorage.getItem(key);
  }

  private set(key: string, value: string | number | boolean) {
    sessionStorage.setItem(key.toString(), value.toString());
  }

  get useProxy() {
    return environment.useProxy;
  }

}
